import { createAction, props } from '@ngrx/store';

import { MediaFile } from '@live/reducers/live-media-files.reducer';

import INextPage = Microsoft.VideoIndexer.Contracts.INextPage;
import ILiveMediaFile = Microsoft.VideoIndexer.Live.Contracts.ILiveMediaFile;
import ILiveTag = Microsoft.VideoIndexer.Live.Contracts.ILiveTag;

export const listMediaFiles = createAction('[Live MediaFiles/API] list media-files');
export const listMediaFilesStarted = createAction('[Live MediaFiles] list media-files started');
export const listMediaFilesSucceeded = createAction(
  '[Live MediaFiles/API] list media-files success',
  props<{ mediaFiles: ILiveMediaFile[]; nextPage: INextPage }>()
);
export const listMediaFilesFailed = createAction('[Live MediaFiles/API] list media-files failure', props<{ error: string }>());
export const clearMediaFiles = createAction('[Live MediaFiles] clear media-files');
export const loadMediaFilesNextPage = createAction('[Live MediaFiles] load media-files next page');
export const goToMediaFilePage = createAction(
  '[Live MediaFiles] go to media-file page',
  props<{ mediaFileId: string; cameraId?: string; time?: number }>()
);
export const getMediaFileSucceeded = createAction('[Live MediaFiles/API] get media-file success', props<{ mediaFile: MediaFile }>());
export const getMediaFileFailed = createAction('[Live MediaFiles/API] get media-file failure', props<{ mediaFileId: string }>());

export const listAllCameraMediaFiles = createAction('[Live MediaFiles/API] list all camera media-files', props<{ cameraId: string }>());
export const listAllCameraMediaFilesSucceeded = createAction(
  '[Live MediaFiles/API] list all camera media-files success',
  props<{ mediaFiles: ILiveMediaFile[]; nextPage: INextPage }>()
);
export const listAllCameraMediaFilesFailed = createAction('[Live MediaFiles/API] list all camera media-files failure', props<{ error: string }>());

export const openDeleteMediaFileDialog = createAction('[Live MediaFiles] Open delete media-file dialog', props<{ mediaFile: ILiveMediaFile }>());

export const deleteMediaFile = createAction('[Live MediaFiles/API] delete media-file', props<{ mediaFileId: string }>());
export const deleteMediaFileSucceeded = createAction('[Live MediaFiles/API] delete media-file success', props<{ mediaFileId: string }>());
export const deleteMediaFileFailed = createAction('[Live MediaFiles/API] delete media-file failure', props<{ error: string }>());

export const updateVideoTags = createAction('[Live MediaFiles/API] Update Video Tags', props<{ mediaFileId: string; desiredTagValues: string[] }>());
export const updateVideoTagsSucceeded = createAction('[Live MediaFiles/API] Update Video Tags Success', props<{ mediaFileId: string }>());
export const updateVideoTagsFailed = createAction('[Live MediaFiles/API] Update Video Tags Failure', props<{ mediaFileId: string; error: string }>());

export const loadVideoTags = createAction('[Live MediaFiles/API] Load Video Tags', props<{ mediaFileId: string }>());
export const loadVideoTagsSucceeded = createAction(
  '[Live MediaFiles/API] Load Video Tags Success',
  props<{ mediaFileId: string; tags: ILiveTag[] }>()
);
export const loadVideoTagsFailed = createAction('[Live MediaFiles/API] Load Video Tags Failure', props<{ mediaFileId: string; error: string }>());
export const openMediaFileReIndexDialog = createAction('[Live MediaFiles] Open media upload re-index dialog', props<{ videoId: string }>());

export const openRenameMediaFileDialog = createAction('[Live MediaFiles] Open rename media-file dialog', props<{ mediaFile: ILiveMediaFile }>());

export const renameMediaFile = createAction(
  '[Live MediaFiles/API] rename media-file',
  props<{ mediaFileId: string; newName: string; startTime: string }>()
);
export const renameMediaFileSucceeded = createAction(
  '[Live MediaFiles/API] rename media-file success',
  props<{ mediaFileId: string; newName: string }>()
);
export const renameMediaFileFailed = createAction('[Live MediaFiles/API] rename media-file failure', props<{ error: string }>());
